/**
 *
 */
export default (theme) => {
    const { colors } = theme['foundations-library']
    return {
        avatar: {
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '50%',
            background: colors.neutral['700']

        },
        favorite: {
            position: 'absolute',
            right: '-5px',
            bottom: 0
        }
    }
}
